// extracted by mini-css-extract-plugin
export default {"body":"style_body__ECw0D","container":"style_container__QJ2Oi","action":"style_action__0OVtO"};